










































import { Component, Vue, Watch } from 'vue-property-decorator'
import Avatar from '@/apps/open/components/Avatar'
import AdminLayout from '@/apps/open/layout/AdminLayout.vue'
import List from './List.vue'
import { getDeveloperSetting } from '@/apps/open/services/developer'
import AddAdminDialogBody from '@/apps/open/components/DialogBodys/AddAdmin.vue'
import store from '@/apps/open/store'
import { onRequestError } from '../../../utils'
import DepartmentDialog from '@/apps/open/components/DialogBodys/DepartmentDialog/index.js'
import { addAdmin } from '@/apps/open/services/admin'

@Component({
  components: {
    Avatar,
    List,
    AdminLayout,
    DepartmentDialog
  }
})
export default class Index extends Vue {
  tabs = [{
    name: '超级管理员',
    key: 'supper-admin'
  }, {
    name: '普通管理员',
    key: 'admin'
  }]
  selectedTab: any = this.tabs[1]
  breadcrumbs: any = [{
    name: this.tabs[1].name
  }]
  users: any = []
  tableData: any = []
  loading = false

  adminLimit = 0

  selectedMembers = []
  disabledAccountIDs: number[] = []

  isShowSelAdminDialog = false

  get isShowAddAdmin () {
    return this.isPrivate ? (this.curEnterprise.developer_type !== 0) : true
  }

  get isPrivate () {
    return this.$store.getters['isPrivate']
  }

  switchSelAdminDialog () {
    this.isShowSelAdminDialog = !this.isShowSelAdminDialog
  }

  async handledMemberConfig (users: any[]) {
    const userIds: number[] = []
    const members = users.map(({ id, name, avatar }) => {
      userIds.push(id)
      return {
        userid: id,
        username: name,
        avatar
      }
    })
    const nameMap = Object.create(null)
    members.forEach(member => {
      nameMap[member.userid] = member.username
    })
    try {
      const res = await addAdmin(userIds, this.curEnterprise.developer_id)
      const resArray = res.data.object_array
      if (resArray && resArray.length > 0) {
        let errorMsg = ''
        resArray.forEach(({ userid }: any) => {
          nameMap[userid] && (errorMsg += `${nameMap[userid]}，`)
        })
        throw new Error(`${errorMsg.slice(0, -1)}添加失败`)
      } else {
        this.showAddSuccessDialog(members)
      }
    } catch (err) {
      onRequestError(err)
    } finally {
      this.load()
    }
  }

  get isSuperAdmin () {
    return this.selectedTab.key === this.tabs[0].key
  }

  get remainTotal () {
    const remain = this.adminLimit - this.users.length
    return remain < 0 ? 0 : remain
  }

  get curEnterprise () {
    return this.$store.getters['User/curEnterprise']
  }

  @Watch('selectedTab', { immediate: true })
  onTabChange (newValue: string, oldValue: string) {
    this.breadcrumbs[0].name = this.selectedTab.name
    this.tableData = []
    this.load()
  }

  async load () {
    this.loading = true
    try {
      await this.$store.dispatch('Admin/GET_ADMIN_LIST')
      if (this.isSuperAdmin) {
        this.tableData = this.$store.getters['Admin/superAdminList']
      } else {
        this.users = this.$store.getters['Admin/generalAdminList']
        this.tableData = this.users
      }
      this.disabledAccountIDs = this.tableData.map((user: any) => user.userid)
    } catch (error) {
      onRequestError(error)
    }
    this.loading = false
  }

  showAddDialog () {
    if (this.isPrivate) {
      this.switchSelAdminDialog()
    } else {
      this.$dialog.show({
        title: '添加管理员',
        body: AddAdminDialogBody,
        bodyProps: {
          onCancel: this.$dialog.close,
          onOk: this.showAddSuccessDialog
        }
      })
    }
  }

  showAddSuccessDialog (users: any) {
    const dialogBody = `
      <div class="desc">
        <div style="color: #000">
          ${`${users[0].username} ${users.length > 1 ? `等${users.length}名用户添加成功!` : '添加成功!'}`}
        </div>
        <div style="color: #7D8188">
          若普通管理员需要访问已添加的应用，请超级管理员在「应用详情 > 基本设置」添加开发人员即可
        </div>
      </div>
    `
    this.load()
    this.$dialog.show({
      title: '添加管理员',
      body: dialogBody,
      buttons: [{ text: '关闭' }]
    })
  }

  onRemoveUser (userid: number) {
    this.users = this.users.filter((item: any) => item.userid !== userid)
    this.tableData = this.users
    this.disabledAccountIDs = this.disabledAccountIDs.filter((item: any) => item !== userid)
  }

  mounted () {
    this.getAdminLimit()
  }

  async getAdminLimit () {
    try {
      const res = await getDeveloperSetting(this.curEnterprise && this.curEnterprise.developer_id)
      this.adminLimit = res.data.object.engineer_limit
    } catch (err) {
      this.$message.error(err.message)
    }
  }
}
